import formSerialize from "form-serialize";

const coerceValue = (key: string, value: string) => {

    let result;

    const split = key.split(":");

    if(split.length > 1) {

        const conversionTypes = split[1].split(",");

        const conversionTypesSansNullable = conversionTypes.filter(type => { return type !== "nullable" });

        if(conversionTypesSansNullable.length !== conversionTypes.length && !value.length) {

            result = null;

        } else {
            // TODO Only the first element is used.
            switch(conversionTypesSansNullable[0]) {
                case "boolean":
                    result = value === "true";
                    break;
                case "number":
                    const t = parseFloat(value);

                    if(isNaN(t)) {
                        throw new Error("Invalid number supplied.");
                    }

                    result = t;
                    break;
                default:

                    result = value;
                    //throw new Error("Unknown coercion type. ");
            }
        }
    } else {

        result = value;

    }

    return { [split[0]]: result };
};

const serialize = (o: object) => {

    let result = {};

    for(const key in o) {
        let value: any = o[key];

        if(typeof value === "string") {

            result = { ...result, ...coerceValue(key, value as string) }

        } else if(value instanceof Array) {

            throw new Error("Not yet implemented");

        } else if(typeof  value === "object") {
            result = { ...result, [key]: serialize(value) }
        }
    }

    return result;
};

export const serializeForm = (form: HTMLFormElement) => {
    return serialize(formSerialize(form, { hash: true, disabled: true, empty: true }));
};